import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Simple in-memory cache so all pages share one fetch.
let _cache = null;
let _pending = null;
const _subs = new Set();

async function fetchContent() {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = axios.get(`${BACKEND}/api/content`).then((r) => {
    _cache = r.data;
    _pending = null;
    _subs.forEach((cb) => cb(_cache));
    return _cache;
  }).catch(() => {
    _pending = null;
    _cache = {};
    return _cache;
  });
  return _pending;
}

export function invalidateSiteContent() { _cache = null; _pending = null; fetchContent(); }

export default function useSiteContent() {
  const [content, setContent] = useState(_cache || {});
  useEffect(() => {
    let cancelled = false;
    fetchContent().then((c) => { if (!cancelled) setContent(c); });
    const cb = (c) => { if (!cancelled) setContent(c); };
    _subs.add(cb);
    return () => { cancelled = true; _subs.delete(cb); };
  }, []);
  return content;
}
